<template>
  <div class="home">
    <div class="header">
      <img alt="Vue logo" src="../assets/image/湖北毅瑞数据科技有限公司.png" />
      <div>
        <el-menu
          :default-active="$route.path"
          :router="true"
          class="el-menu-demo"
          mode="horizontal"
        >
          <el-menu-item index="/HomePage" :route="{ path: '/HomePage' }"
            >首页</el-menu-item
          >
          <el-menu-item
            index="/BimFullProcessService"
            :route="{ path: '/BimFullProcessService' }"
            >BIM全过程应用服务</el-menu-item
          >
          <el-menu-item
            index="/SmartDigitalService"
            :route="{ path: '/SmartDigitalService' }"
            >智慧街区数字化服务</el-menu-item
          >
          <el-menu-item
            index="/IotPerceptionService"
            :route="{ path: '/IotPerceptionService' }"
            >物联感知服务</el-menu-item
          >
          <el-menu-item
            index="/DigitalTerrainService"
            :route="{ path: '/DigitalTerrainService' }"
            >数字地形服务</el-menu-item
          >
          <el-menu-item
            index="/PlatformCustomization"
            :route="{ path: '/PlatformCustomization' }"
            >平台定制开发</el-menu-item
          >
          <el-menu-item index="/AboutUs" :route="{ path: '/AboutUs' }"
            >关于我们</el-menu-item
          >
          <!-- <el-menu-item index="/ContactUs" :route="{ path: '/ContactUs' }"
            >联系我们</el-menu-item
          > -->
        </el-menu>
      </div>
    </div>
    <el-main>
      <router-view />
    </el-main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "1",
    };
  },
  methods: {
    handleClick(val) {
      if (val.name == "7") {
        this.$nextTick(() => {
          this.$refs.contactUsRef.initMap();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  .header {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 80px;
    box-sizing: border-box;
    img {
      width: 450px;
      height: 55px;
      object-fit: contain;
    }
  }
}
.el-main {
  margin: 0;
  padding: 0;
}
::v-deep .el-tabs__item {
  font-size: 16px !important;
}
</style>
